import React from 'react';
import {Alert, Box, Stack} from '@mui/material';
import {Body, Button, Icon} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import LEGACY_COLORS from '@/config/legacyColors';
import styles from '../CreatorSidePanel.module.scss';

type QuickViewTabProps = {
  portfolioImages: string[];
  unreadMessagesCount: number;
  onViewMessages: () => void;
  onViewFullProfile: () => void;
};

function QuickViewTab({
  portfolioImages,
  unreadMessagesCount,
  onViewMessages,
  onViewFullProfile,
}: QuickViewTabProps) {
  const leftColumnImages = portfolioImages.filter(
    (_url, index) => index % 2 === 0
  );
  const rightColumnImages = portfolioImages.filter(
    (_url, index) => index % 2 === 1
  );

  return (
    <>
      <Box className={styles.tabContent}>
        {unreadMessagesCount > 0 && (
          <Alert
            severity="info"
            className={styles.unreadAlert}
            action={
              <Button
                variant="text"
                className={styles.unreadAlertAction}
                onClick={onViewMessages}
              >
                {translate('View')}
              </Button>
            }
          >
            <Body size="md" color={LEGACY_COLORS.PURPLE_DARK}>
              {translate('unread_messages', {count: unreadMessagesCount})}
            </Body>
          </Alert>
        )}

        {portfolioImages.length > 0 && (
          <Stack direction="row" className={styles.contentGrid}>
            <Stack className={styles.contentColumn}>
              {leftColumnImages.map((url) => (
                <img
                  key={url}
                  src={url}
                  alt=""
                  className={styles.contentThumbnail}
                />
              ))}
            </Stack>
            <Stack className={styles.contentColumn}>
              {rightColumnImages.map((url) => (
                <img
                  key={url}
                  src={url}
                  alt=""
                  className={styles.contentThumbnail}
                />
              ))}
            </Stack>
          </Stack>
        )}
      </Box>

      <Box className={styles.footer}>
        <Button
          className={styles.viewFullProfileButton}
          appearance="neutral"
          mode="tinted"
          size="medium"
          onClick={onViewFullProfile}
          icon={
            <Icon
              size="small"
              appearance="neutral"
              name="Actions-Arrow-Long-Forward"
            />
          }
          iconPosition="end"
        >
          {translate('View full profile')}
        </Button>
      </Box>
    </>
  );
}

export default QuickViewTab;
